import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import * as sitePreferencesActionsCreators from '../../../redux/css-admin/sitePreferences/operations'
import { connect } from 'react-redux'
import SitePreferences from './SitePreferences'

function SitePreferencesContainer(props) {
  let formattedUploadResults
  if (!!props.uploadResults) {
    const { sitePreferencesResults = [], errors = [] } =
      props.uploadResults || {}

    formattedUploadResults = sitePreferencesResults.map(
      sitePreferencesResult => ({
        siteId: sitePreferencesResult.siteId,
        siteName: sitePreferencesResult.siteName,
      }),
    )

    if (errors.length > 0) {
      errors.forEach(error => {
        formattedUploadResults.unshift({
          siteId: error.siteId,
          siteName: error.siteName,
          rowNumber: error.rowNumber,
          error: error.error,
        })
      })
    }
  }

  return (
    <SitePreferences
      {...props}
      formattedUploadResults={formattedUploadResults}
    />
  )
}

const mapStateToProps = ({ sitePreferencesManager }) => {
  return {
    ...sitePreferencesManager,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...sitePreferencesActionsCreators,
    },
    dispatch,
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SitePreferencesContainer)



// WEBPACK FOOTER //
// ./src/containers/css-admin/sitePreferences/SitePreferencesContainer.js